import { render, staticRenderFns } from "./VenueNew.vue?vue&type=template&id=009d89da"
import script from "./VenueNew.vue?vue&type=script&lang=ts"
export * from "./VenueNew.vue?vue&type=script&lang=ts"
import style0 from "./VenueNew.vue?vue&type=style&index=0&id=009d89da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports